const items = [
  {
    icon: 'ri-server-line',
    title: 'Технический мониторинг',
    text: 'Сайт всегда онлайн и работает быстро.',
    extra: null,
  },
  {
    icon: 'ri-shield-check-line',
    title: 'SEO-защита',
    text: 'Сохранение и рост позиций в поиске.',
    extra: null,
  },
  {
    icon: 'ri-article-line',
    title: 'Ежемесячная SEO-статья',
    text: 'Новая «точка входа» для бесплатных клиентов из поиска.',
    extra: 'До 5 правок контента: Оперативное изменение цен, акций или фото.',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'Ежемесячный отчёт',
    text: 'Понятные цифры — сколько людей пришло и как выросла видимость сайта.',
    extra: null,
  },
];

export default function SupportPackage() {
  return (
    <section className="py-14 sm:py-24 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 sm:mb-6 leading-tight">
            Что вы получаете<br /> в пакете «Сопровождение»
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {items.map((item, idx) => (
            <div
              key={idx}
              className="group flex gap-4 sm:gap-6 bg-white border border-gray-100 rounded-2xl p-5 sm:p-8 hover:border-[#C5A880]/40 transition-all duration-300"
            >
              <div className="flex-shrink-0 w-11 h-11 sm:w-14 sm:h-14 rounded-xl sm:rounded-2xl bg-[#1A2B4C] flex items-center justify-center group-hover:bg-[#C5A880] transition-colors duration-300">
                <i className={`${item.icon} text-lg sm:text-2xl text-white`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm sm:text-xl font-bold text-[#1A2B4C] mb-2 font-['Playfair_Display'] leading-snug">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed font-['Montserrat']">
                  {item.text}
                </p>
                {item.extra && (
                  <p className="text-gray-500 text-xs sm:text-sm leading-relaxed font-['Montserrat'] mt-2 pt-2 border-t border-gray-100">
                    <span className="text-[#C5A880] font-semibold">+ </span>
                    {item.extra}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="mt-8 sm:mt-14 bg-gradient-to-r from-[#1A2B4C] to-[#253D6B] rounded-2xl sm:rounded-3xl p-6 sm:p-10 text-center">
          <p className="text-white/80 text-xs font-['Montserrat'] mb-2 uppercase tracking-widest font-semibold">
            Всё включено в один пакет
          </p>
          <h3 className="text-xl sm:text-3xl font-['Playfair_Display'] font-bold text-white mb-5 sm:mb-6 leading-tight">
            Ваш сайт под постоянной защитой и развитием
          </h3>
          <a
            href="#support-form"
            className="inline-flex items-center gap-2 bg-[#C5A880] hover:bg-[#B39770] text-white px-7 sm:px-10 py-3 sm:py-4 rounded-full font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap text-sm sm:text-base cursor-pointer font-['Montserrat']"
          >
            Подключить сопровождение
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
